import {Component,Input} from '@angular/core';
import {FormGroup} from '@angular/forms';

import {InputBase} from '../InputBase';

@Component({
    selector: 'dynamic-input',
    templateUrl:'dynamicinput.component.html'
})
export class DynamicInputComponent{
    @Input()
    disabled:boolean = false;

    @Input()
    input!: InputBase<any>;
    @Input()
    form!: FormGroup;
    
    
    get isValid(){
        return this.form.controls[this.input.key].valid;
    }


    clearValue(){
        this.form.controls[this.input.key].setValue("");
    }

}